<div div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <h2 id="viewRemitosHeaderTitle" class="page-header" fxFlex="fill" fxFlexAlign="baseline">Consulta e impresión de
    Remitos</h2>
  <div id="viewRemitosHeaderButtons" fxFlex="noshrink" fxFlexAlign="baseline" fxFlexAlign="flex-end">
    <app-print-email-remitos-button *ngIf="showPrintEmailAllButtons" [disabled]="disablePrintEmailAllButtons"
                                    [type]="'print'" [remitos]="printEmailNros"
                                    (printEmailCompletedEvent)="refreshRemitoList()"></app-print-email-remitos-button>
    <app-print-email-remitos-button *ngIf="showPrintEmailAllButtons" [disabled]="disablePrintEmailAllButtons"
                                    [type]="'email'" [remitos]="printEmailNros"
                                    (printEmailCompletedEvent)="refreshRemitoList()"></app-print-email-remitos-button>
  </div>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
    <div #tableContainer class="table-height" fxLayout="column">
      <table mat-table [dataSource]="dataSource" matSort [matSortActive]="initialSortField" [matSortDirection]="initialSortDirection" matSortDisableClear (matSortChange)="onSortChange()" #dataTable>
        <!-- Row Checkbox -->
        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="center">
            <mat-checkbox *ngIf="showPrintEmailAllButtons" (change)="onChange(element)" [(ngModel)]="element.isChecked"
                          [disabled]="this.remitoNumber.length === 5 && !element.isChecked">
            </mat-checkbox>
          </td>
        </ng-container>
        <!-- Nro Remito Column -->
        <ng-container matColumnDef="nroRemito">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro Remito
            <rem-string-filter #tableFilter columnDef="nroRemito" [operators]="operators"
                               (filterChange)="filterChange($event);"></rem-string-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center">
            <span>
              <a [routerLink]="['/create-remito/'+ element.ptoEmision + '/' + element.nroRemito]">
                {{element.nroRemito}}
              </a>
            </span>
          </td>
        </ng-container>
        <!-- Solicitante Column -->
        <ng-container matColumnDef="nameSolicitante">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Solicitante
            <rem-string-filter #tableFilter columnDef="nameSolicitante" [operators]="operators"
                               (filterChange)="filterChange($event);"></rem-string-filter>
          </th>
          <td mat-cell class="center" *matCellDef="let element">
            <span *ngIf="element.nameSolicitante != null; else inactiveSolicitante">
              {{element.nameSolicitante}}
            </span>
            <ng-template #inactiveSolicitante>
              <mat-icon *ngIf="element.remitoType === 'Free'" id="inactive-solicitante-indicator" color="warn"
                        matTooltip="Solicitante no está activo.">info
              </mat-icon>
            </ng-template>
          </td>
        </ng-container>
        <!-- Almacen Column -->
        <ng-container matColumnDef="codAlmacen">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Almacen
            <rem-string-filter #tableFilter columnDef="almacen" [operators]="operators"
                               (filterChange)="filterChange($event);"></rem-string-filter>
          </th>
          <td mat-cell class="center" *matCellDef="let element">  {{ element.almacen }} </td>
        </ng-container>
        <!-- Dock Column -->
        <ng-container matColumnDef="dock">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód Dock
            <rem-string-filter #tableFilter columnDef="dock" [operators]="operators"
                               (filterChange)="filterChange($event);"></rem-string-filter>
          </th>
          <td mat-cell class="center" *matCellDef="let element"> {{element.dock}} </td>
        </ng-container>
        <!-- Fec Gen Column -->
        <ng-container matColumnDef="fecGen">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Gen
            <rem-date-filter #tableFilter columnDef="fecGen" [operators]="dateOperators"
                             (filterChange)="filterChange($event);"></rem-date-filter>
          </th>
          <td mat-cell class="center" *matCellDef="let element"> {{element.fecGen | customDate}} </td>
        </ng-container>
        <!-- Fec Modif Column -->
        <ng-container matColumnDef="fecModif">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Modif
            <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                             (filterChange)="filterChange($event);"></rem-date-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center"> {{element.fecModif | customDate}} </td>
        </ng-container>
        <!-- Fec a Retornar Column -->
        <ng-container matColumnDef="fecARetornar">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec a Retornar
            <rem-date-filter #tableFilter columnDef="fecARetornar" [operators]="dateOperators"
                             (filterChange)="filterChange($event);"></rem-date-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center"> {{element.fecARetornar | customDate}} </td>
        </ng-container>
        <!-- Fec Prorrogas Column -->
        <ng-container matColumnDef="fecProrrogas">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Prorrogas
            <rem-date-filter #tableFilter columnDef="fecProrrogas" [operators]="dateOperators"
                             (filterChange)="filterChange($event);"></rem-date-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center"> {{element.fecProrrogas | customDate}} </td>
        </ng-container>
        <!-- Fec Retorno Column -->
        <ng-container matColumnDef="fecRetorno">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Retorno
            <rem-date-filter #tableFilter columnDef="fecRetorno" [operators]="dateOperators"
                             (filterChange)="filterChange($event);"></rem-date-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center"> {{element.fecRetorno | customDate}} </td>
        </ng-container>
        <!-- Status Column -->
        <ng-container matColumnDef="estadoRemito">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado
            <rem-string-filter #tableFilter columnDef="estadoRemito" [operators]="operators"
                               (filterChange)="filterChange($event);"></rem-string-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center">
            {{element.estadoRemito}}
          </td>
        </ng-container>
        <!-- Nro Shipper Column -->
        <ng-container matColumnDef="nroShipper">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro Shipper
            <rem-string-filter #tableFilter columnDef="nroShipper" [operators]="operators"
                               (filterChange)="filterChange($event);"></rem-string-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center">
            {{element.nroShipper}}
          </td>
        </ng-container>
        <!-- remito Type Column -->
        <ng-container matColumnDef="remitoType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo de Remito
            <rem-string-filter #tableFilter columnDef="remitoType" [operators]="operators"
                               (filterChange)="filterChange($event);"></rem-string-filter>
          </th>
          <td mat-cell *matCellDef="let element" class="center">
            {{element.remitoType}}
          </td>
        </ng-container>
        <!-- Print Button Column -->
        <ng-container matColumnDef="remitoButtons">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" nowrap="true">
            <app-print-email-remitos-button *ngIf="canPrint && !isBalanza(element)" [disabled]="disableRemitoButtons"
                                            (printEmailCompletedEvent)="refreshRemitoList()"
                                            [type]="'print'"
                                            [remitos]="[{ptoEmision: element.ptoEmision, nroRemito: element.nroRemito}]"></app-print-email-remitos-button>
            <app-print-email-remitos-button *ngIf="canEmail && !isBalanza(element)" [disabled]="disableRemitoButtons"
                                            (printEmailCompletedEvent)="refreshRemitoList()"
                                            [type]="'email'"
                                            [remitos]="[{ptoEmision: element.ptoEmision, nroRemito: element.nroRemito}]"></app-print-email-remitos-button>
            <button mat-icon-button class="view-remito-buttons" *ngIf="estaCancelado(element)"
                    (click)="verCancelarObservacion(element)" [disabled]="disableRemitoButtons">
              <mat-icon>comment</mat-icon>
            </button>
            <button mat-icon-button class="view-remito-buttons"
                    *ngIf="canCancel && !estaCancelado(element)"
                    (click)="cancelarRemito(element)" [disabled]="disableRemitoButtons">
              <mat-icon>cancel</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  <mat-paginator #paginator
                 [pageSize]="pageSizes[0]"
                 [pageSizeOptions]="pageSizes"
                 [length]="totalElements"
                 (page)="updatePageState()">
  </mat-paginator>
</div>

